// The presentation script's deliberately tongue-in-cheek spectacle beat. This is audience copy,
// not a new gameplay mode: the match that follows is the ordinary score-based Live Match and a
// queen elimination still ends it immediately.

import type { ReactElement } from 'react';
import { DeathMatchFrame } from './SlideFrame';
import { SLIDE_SCALE } from './scale';
import './slides.css';

export function PvpIntroductionSlide(): ReactElement {
  return (
    <DeathMatchFrame center>
      <div style={{ display: 'grid', textAlign: 'center' }}>
        <h1
          className="deathmatch-title"
          style={{
            margin: 0,
            fontFamily: 'var(--font-display)',
            fontWeight: 900,
            fontSize: SLIDE_SCALE.hero * 2,
            lineHeight: 'var(--leading-tight)',
            letterSpacing: '-0.035em',
            color: 'white',
          }}
        >
          DEATHMATCH
        </h1>
      </div>
    </DeathMatchFrame>
  );
}
